import { FaArrowCircleDown, FaArrowCircleUp, FaFileUpload } from "react-icons/fa";
import { getApp, initializeApp } from "firebase/app";
import { getDownloadURL, getMetadata, getStorage,ref, uploadBytes, uploadBytesResumable } from "firebase/storage";
import { useEffect, useState } from "react";
import { doc, getDoc, getFirestore, onSnapshot, setDoc } from "firebase/firestore";
import { AiOutlineArrowUp, AiOutlineDelete } from "react-icons/ai";

const firebaseConfig = {
    apiKey: "AIzaSyDvyFE51u8HLshOA9RPHIX49CqSpT62VU4",
    authDomain: "funnel-887b0.firebaseapp.com",
    databaseURL: "https://funnel-887b0.firebaseio.com",
    projectId: "funnel-887b0",
    storageBucket: "funnel-887b0.appspot.com",
    messagingSenderId: "948800714095",
    appId: "1:948800714095:web:289b59b34a9aec463ba49a",
    measurementId: "G-0TG7HL2T80"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore();
const storage = getStorage();


export default function SliderImages(){

    const [imagesList,setImagesList] = useState([]);
    
    useEffect(async()=>{
        
        const unsub = onSnapshot(doc(db, "appSettings", "images"), (doc) => {
            var data=doc.data();
            var bannerList=data["bannerImages"]===undefined?[]:data["bannerImages"];
            setImagesList([...bannerList]);
        });
       
    },[]);

    return(
        <div className="bg-white/10 h-[750px] w-full flex flex-row rounded">

            <div className="w-1/4 flex justify-center items-center border-1 border-white/50 rounded">
                <button 
                    onClick={()=>{
                        var input = document.createElement('input');
                        input.type = 'file';
                        input.click();
                        input.onchange = e => { 
                            var file = e.target.files[0];
                        
                            const imagesRef=ref(storage,`sliders/${file.name}`);
                                
                            const uploadTask = uploadBytesResumable(imagesRef, file);
                            uploadTask.on("state_changed",(snapshot)=>{
                                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                                console.log('Upload is ' + progress + '% done');
                            },
                            ()=>{},
                            ()=>{
                                getDownloadURL(uploadTask.snapshot.ref).then(async (url)=>{
                                    console.log(url);
                                    var data= (await getDoc(doc(db,"appSettings","images"))).data();
                                    var bannerList=data["bannerImages"];
                                    bannerList.push(url);
                                    await setDoc(doc(db,"appSettings","images"),{"bannerImages":bannerList},{merge:true});    
                                    console.log("banner list is"+bannerList);
                                })
                            }
                            )
                        

                            
                            console.log("uploading a file");

                        }   
                    }}    
                    className="h-3/4 w-full flex justify-center items-center">
                        <FaFileUpload color={"white"} size={100} className="self-center"/>
                </button>
            </div>

            <div className=" h-full w-3/4 overflow-scroll">
                    {
                        imagesList.map((e,imageIndex)=>{
                            return(
                                <div key={imageIndex} className="pl-2 mt- rounded-xl h-72 w-full flex flex-row">

                                    <div
                                    style={{backgroundImage:`url(${e})`}}
                                    className=" rounded h-72 w-3/4 bg-contain bg-center bg-no-repeat">
                                    </div>



                                    <div className="h-full w-1/4 flex justify-center items-center flex flex-row">

                                        <div className="flex flex-col pr-5 justify-center items-center ">
                                            <div className="h-12 w-12">


                                                <FaArrowCircleUp
                                                onClick={async ()=>{
                                                    var data= (await getDoc(doc(db,"appSettings","images"))).data();
                                                    var bannerList=data["bannerImages"];
                                                    var previous=bannerList[imageIndex-1];
                                                    var current=bannerList[imageIndex];

                                                    if(imageIndex!=0){
                                                        bannerList[imageIndex-1]=current;
                                                        bannerList[imageIndex]=previous;
                                                        await setDoc(doc(db,"appSettings","images"),{"bannerImages":bannerList},{merge:true});    
                                                        console.log("banner list is"+bannerList);
                                                    }

                                                }}
                                                className="mb-4 hover:scale-110 " color="white" size={40} />



                                                <FaArrowCircleDown
                                                 onClick={async ()=>{
                                                    var data= (await getDoc(doc(db,"appSettings","images"))).data();
                                                    var bannerList=data["bannerImages"];
                                                    var future=bannerList[imageIndex+1];
                                                    var current=bannerList[imageIndex];

                                                    if(imageIndex!=(bannerList.length-1)){
                                                        bannerList[imageIndex+1]=current;
                                                        bannerList[imageIndex]=future;
                                                        await setDoc(doc(db,"appSettings","images"),{"bannerImages":bannerList},{merge:true});    
                                                        console.log("banner list is"+bannerList);
                                                    }

                                                }}
                                                className="mb-4 hover:scale-110" 
                                                color="white" size={40} />



                                            </div>
                                        </div>

                                        <button
                                        onClick={async()=>{
                                            var data= (await getDoc(doc(db,"appSettings","images"))).data();
                                            var bannerList=data["bannerImages"];
                                            bannerList.splice(imageIndex,1);
                                            await setDoc(doc(db,"appSettings","images"),{"bannerImages":bannerList},{merge:true});    
                                            console.log("banner list is"+bannerList);
                                        }}
                                        className="bg-white/50 p-2 rounded hover:scale-105 hover:bg-red-500 flex justify-center items-center">
                                            <AiOutlineDelete size={30}/>
                                        </button> 


                                    </div>    



                                </div>  
                            )
                        })
                    }
            </div>

        

        </div>
    )
}